// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card_detail_top_section_wrapper {
    width: 100%;
    display: grid;
    grid-template-columns: 37% 1fr;
    grid-gap: 32px;
}

.card_detail_top_section_container.info > h4 {
    font-size: 17px;
    font-weight: bold;
    color: #3D3D8E;
}

.card_detail_top_section_container.info > h5 {
    font-size: 16px;
    font-weight: normal;
    color: #666666;
    margin-top: 10px;
    margin-bottom: 30px;
}

.card_detail_top_section_container.info > p {
    font-size: 14px;
    font-weight: normal;
    color: #707070;
    margin-bottom: 16px;
}

.card_detail_top_section_info_container {
    margin-left: 12px;
    width: calc(100% - 12px);
    padding: 16px;
    background-color: #F3F3F3;
    display: grid;
    grid-template-columns: 62px 1fr;
    align-items: center;
    margin-bottom: 16px;
}

.card_detail_top_section_info_container > div > p {
    font-size: 14px;
    font-weight: normal;
    color: #707070;
}

.card_detail_top_section_container {
    background-color: #ffffff;
    padding: 16px;
    border-radius: 3px;
    border: 1px dashed #8F9BB3;
}

.card_detail_top_section_container_title {
    font-size: 18px;
    color: #0D0A3D;
    margin-bottom: 7px;
}

.card_detail_top_section_container_label_container {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    padding-right: 20px;
}

.card_detail_top_section_container_label {
    font-size: 18px;
    color: #0D0A3D;
    margin-bottom: 7px;
    position: relative;
}

.card_detail_top_section_container_label:after {
    position: absolute;
    content: "";
    width: 15px;
    height: 15px;
    border-radius: 50%;
    background-color: #8AC142;
    z-index: 1;
    margin-left: 5px;
    top: 4px;
}

.card_detail_top_section_container_label.small:after {
    width: 10px;
    height: 10px;
}

.card_detail_top_section_container_label.supermarket:after {
    background-color: #946EC6;
}

.daily_chart_top_section_container {
    width: 100%;
    display: flex;
    justify-content: space-around;
    align-items: center;
}

.daily_chart_top_section_container_chart {
    width: 340px;
    height: 200px;
    margin-left: auto;
    margin-right: auto;
}
`, "",{"version":3,"sources":["webpack://./src/Components/Pages/Payments/CardDetail/TopSections/CardDetailTopSection.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,aAAa;IACb,8BAA8B;IAC9B,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,cAAc;IACd,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,wBAAwB;IACxB,aAAa;IACb,yBAAyB;IACzB,aAAa;IACb,+BAA+B;IAC/B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,aAAa;IACb,kBAAkB;IAClB,0BAA0B;AAC9B;;AAEA;IACI,eAAe;IACf,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,UAAU;IACV,gBAAgB;IAChB,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,aAAa;IACb,6BAA6B;IAC7B,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,iBAAiB;IACjB,kBAAkB;AACtB","sourcesContent":[".card_detail_top_section_wrapper {\n    width: 100%;\n    display: grid;\n    grid-template-columns: 37% 1fr;\n    grid-gap: 32px;\n}\n\n.card_detail_top_section_container.info > h4 {\n    font-size: 17px;\n    font-weight: bold;\n    color: #3D3D8E;\n}\n\n.card_detail_top_section_container.info > h5 {\n    font-size: 16px;\n    font-weight: normal;\n    color: #666666;\n    margin-top: 10px;\n    margin-bottom: 30px;\n}\n\n.card_detail_top_section_container.info > p {\n    font-size: 14px;\n    font-weight: normal;\n    color: #707070;\n    margin-bottom: 16px;\n}\n\n.card_detail_top_section_info_container {\n    margin-left: 12px;\n    width: calc(100% - 12px);\n    padding: 16px;\n    background-color: #F3F3F3;\n    display: grid;\n    grid-template-columns: 62px 1fr;\n    align-items: center;\n    margin-bottom: 16px;\n}\n\n.card_detail_top_section_info_container > div > p {\n    font-size: 14px;\n    font-weight: normal;\n    color: #707070;\n}\n\n.card_detail_top_section_container {\n    background-color: #ffffff;\n    padding: 16px;\n    border-radius: 3px;\n    border: 1px dashed #8F9BB3;\n}\n\n.card_detail_top_section_container_title {\n    font-size: 18px;\n    color: #0D0A3D;\n    margin-bottom: 7px;\n}\n\n.card_detail_top_section_container_label_container {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-end;\n    padding-right: 20px;\n}\n\n.card_detail_top_section_container_label {\n    font-size: 18px;\n    color: #0D0A3D;\n    margin-bottom: 7px;\n    position: relative;\n}\n\n.card_detail_top_section_container_label:after {\n    position: absolute;\n    content: \"\";\n    width: 15px;\n    height: 15px;\n    border-radius: 50%;\n    background-color: #8AC142;\n    z-index: 1;\n    margin-left: 5px;\n    top: 4px;\n}\n\n.card_detail_top_section_container_label.small:after {\n    width: 10px;\n    height: 10px;\n}\n\n.card_detail_top_section_container_label.supermarket:after {\n    background-color: #946EC6;\n}\n\n.daily_chart_top_section_container {\n    width: 100%;\n    display: flex;\n    justify-content: space-around;\n    align-items: center;\n}\n\n.daily_chart_top_section_container_chart {\n    width: 340px;\n    height: 200px;\n    margin-left: auto;\n    margin-right: auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
